module.exports = __webpack_public_path__ + "img/left_3.036e04b4.png";